import React from 'react';
import PropTypes from 'prop-types';
import './index.scss';

/*
 * Type definitions
 */
const propTypes = {
    name: PropTypes.string.isRequired,
    address: PropTypes.string,
    large: PropTypes.bool,
};

const defaultProps = {
    address: '',
    large: false,
};

function StoreBasicInfo({ name, address, large }) {
    let classes = 'store-basic-info';
    if (large) {
        classes += ' large';
    }

    return (
        <div className={classes}>
            <h3 className="title">{name}</h3>
            {address && <p className="address">{address}</p>}
        </div>
    );
}

StoreBasicInfo.propTypes = propTypes;
StoreBasicInfo.defaultProps = defaultProps;

export default StoreBasicInfo;
